// Function to handle smooth scrolling and updating history
function smoothScrollToElement(href) {
    const targetElement = document.querySelector(href);
    if (targetElement) {
      window.scroll({
        top: targetElement.getBoundingClientRect().top + window.scrollY - 120,
        behavior: 'smooth'
      });
      history.pushState(null, '', href);
    }
  }
  
  // Get the button element
  const btnCta = document.getElementById('btn-scroll');
  
  // Add event listener if the button element exists
  if (btnCta) {
    btnCta.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default action of the button
      const href = this.getAttribute('href'); // Get the href attribute of the button
      smoothScrollToElement(href); // Call the smooth scroll function
    });
  }
  